import type {
  UseManualAccessoriesParams,
  UseManualAccessoriesResult
} from 'hooks/use-manual-accessories-types';
import { useManualAccessoryLogger } from 'hooks/use-manual-accessory-logger';
import { useCallback, useMemo } from 'react';
import {
  findManualAccessories,
  selectedAccessoryProductIds
} from 'utils/manual-accessories';
import type { ManualAccessoryChangeHandlerType } from 'utils/manual-accessories-types';

export function useManualAccessories({
  quotableSystemUniqueId,
  accessories,
  onChange
}: UseManualAccessoriesParams): UseManualAccessoriesResult {
  const logManualAccessoryChange = useManualAccessoryLogger(
    quotableSystemUniqueId
  );

  const manualAccessories = useMemo(
    () => findManualAccessories(accessories),
    [accessories]
  );
  const selectedProductIds = useMemo(
    () => selectedAccessoryProductIds(accessories),
    [accessories]
  );

  const handleManualAccessoryChange =
    useCallback<ManualAccessoryChangeHandlerType>(
      (product, quantity, ownerUniqueId) => {
        logManualAccessoryChange(
          manualAccessories,
          product,
          quantity,
          ownerUniqueId
        );
        onChange(product, quantity, ownerUniqueId);
      },
      [logManualAccessoryChange, manualAccessories, onChange]
    );

  return { manualAccessories, selectedProductIds, handleManualAccessoryChange };
}
